var Backbone = require("backbone");
var _ = require("underscore");
var $ = require("jquery");
Backbone.$ = $;

var debug = require("debug")("views:BookmarksView");

/**
 * BookmarksView: affiche l'arbre de bookmarks qui viennent du pdf
 * inspiré de https://www.howtocreate.co.uk/tutorials/jsexamples/listCollapseExample.html
 */
module.exports = Backbone.View.extend({

    enabled: false,
    model: null, // BookmarksModel
    nbVisibleLevels: 1, 

    events: {
        "click span.bm-title": "onBookmarkClicked",
        "click li.bm-collapsable > span.bm-icon": "onIconClicked"
    },

    initialize: function (options) {
        var T = this;
        _.extend(T, options);
        T.listenTo(T.model, "sync", T.onBookmarksLoaded);
    },

    onBookmarksLoaded: function () {
        var T = this;
        T.render();
    },

    render: function () {
        var T = this;
        if (!T.model.fetched) {
            //T.$el.html("Chargement ...");
            return;
        }
        debug("render");

        var bm, next_bm, bms = T.model.get('bookmarks');

        var previous_level = 0;
        var i = 0;
        var $base_ul = $("<ul/>"), $new_ul;
        var $current_ul = $base_ul, $current_li;
        for (i = 0; i < bms.length; i++) {
            bm = bms[i];
            next_bm = bms[i + 1];

            if (bm.level > previous_level) {
                $new_ul = $("<ul/>");
                $current_li.append($new_ul);
                $current_ul = $new_ul;
            } else if (bm.level < previous_level) {
                var diff_level = previous_level - bm.level;
                for (var j = 0; j < diff_level; j++) {
                    $current_ul = $current_ul.parent().parent();
                }
            }

            var $new_li = $("<li/>");
            
            var $new_span_icon = $("<span/>");

            if (next_bm && next_bm.level > bm.level) {
                // il y a des enfants
                $new_li.addClass("bm-collapsable");
                if(bm.level > T.nbVisibleLevels - 2 ){
                    $new_li.addClass("bm-closed"); // on ferme les niveaux supérieurs
                }
            }
            else {
                $new_li.addClass("bm-not-collapsable");
            }
            $new_span_icon.addClass("bm-icon");
            $new_li.append($new_span_icon);
            
            var $new_span_title = $("<span/>");
            $new_span_title.text(bm.title);
            $new_span_title.data("page", bm.page);
            $new_span_title.addClass("bm-title");
            $new_li.append($new_span_title);

            $current_ul.append($new_li);
            $current_li = $new_li;
            
            previous_level = bm.level;
        }
        //str += "</ul>".repeat(previous_level + 1);
        T.$el.append($base_ul);

        // gestion collapsing
    },


    onBookmarkClicked: function (e) {
        var $bm = $(e.currentTarget);
        var page = $bm.data("page");
        this.trigger("click", page);
    },

    onIconClicked: function(e){
        var $icon = $(e.currentTarget);
        $icon.parent().toggleClass("bm-closed");
    },

    close: function () {
        var T = this;
        T.stopListening();
        T.undelegateEvents();
    }

});



//////////////////
// WEBPACK FOOTER
// ./src/views/bookmarks-view.js
// module id = 61
// module chunks = 0